module.exports = __webpack_public_path__ + "img/battle_section5_item2.ddd64f34.png";